<lib-generic-picker
  [buttonText]="buttonText"
  [buttonIcon]="'fas fa-calendar'"
  [ngModel]="val"
  (ngModelChange)="valueChanged($event)"
  [availableButtons]="availableOptions"
  [columns]="3"
  [disableDecrementYear]="disableDecrementYear()"
  [disableIncrementYear]="disableIncrementYear()">
</lib-generic-picker>
